var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bpb-picture',{attrs:{"src":_vm.defaultSource.url,"alt":"","sources":_vm.formattedSources,"source-selector":_vm.forProductExtension ? 'size-orientation' : 'size',"select-size-by":_vm.forProductExtension ? 'auto' : 'width',"copy-size-by":_vm.forProductExtension ? '.teaser-shop__picture' : undefined}})
}
var staticRenderFns = []

export { render, staticRenderFns }